<script>
  import DataTable from '../DataTable/DataTable.svelte';
  import Loader from '../Loader.svelte';
  import InfoAlert from '../Alert/InfoAlert.svelte';
  import { client } from 'root/api/index.js';
  import * as yup from 'yup';
  import { Modal } from 'bootstrap';
  import { createForm } from 'svelte-forms-lib';
  import FormInput from '../FormControls/FormInput.svelte';
  import { setMasterData } from '../../stores/masterData.js';
  import { getContext, onMount } from 'svelte';
  import { configItem } from '../../components/Helper';
  export let unitId;

  let focusInput;
  onMount(() => {
    document.getElementById('projectTypeModal').addEventListener('shown.bs.modal', function () {
      focusInput.focusOnInput();
    });
  });

  let defaultValue = {
    id: '',
    name: '',
    unitId: unitId,
  };

  const getMaster = () => {
    client
      .getMasterData()
      .then((response) => {
        setMasterData(response.data);
      })
      .catch((err) => {});
  };
  let isFormPending = false;
  let serverErrors = [];
  const showDialog = getContext('showDialog');

  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      name: yup.string().required('Delivery vertical name is required'),
    }),
    onSubmit: (values) => {
      isFormPending = true;
      client
        .deliveryVerticalAdd({ ...values, unitId })
        .then((response) => {
          isFormPending = false;
          toggleModal('hide');
          filterData();
          getMaster();
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
        });
    },
  });

  let getData = (queries) => {
    return client.deliveryVerticalList(50, 1, {
      ...queries,
      ...extraFilter,
    });
  };

  let datatableRef;
  let scrollRef;
  let columns = [
    { key: 'name', label: 'Delivery Vertical Name', sortable: true },
    { key: 'active', label: 'Status', sortable: true },
    { key: 'action', label: 'Action', sortable: false },
  ];

  let defaultFilter = {
    searchKeyword: '',
    unitId: unitId,
  };
  let extraFilter = { ...defaultFilter };

  let searchTimeout;
  let firstTimeLoad = true;
  let filterData = () => {
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        if (firstTimeLoad) {
          firstTimeLoad = false;
          return false;
        }
        datatableRef.initializeState();
      }
    }, 250);
  };

  $: unitId && changeUnitId();
  $: extraFilter && filterData();

  function changeUnitId() {
    $form = { ...defaultValue };
    extraFilter.unitId = unitId;
  }

  function toggleModal(flag) {
    if (flag != undefined && flag == 'hide') {
      var modal = Modal.getInstance(document.getElementById('projectTypeModal'));
      modal.hide();
    } else {
      var modal = new Modal(document.getElementById('projectTypeModal'), {
        keyboard: false,
        backdrop: 'static',
      });
      modal.show();
    }
  }

  function showDelete(selectId) {
    showDialog({
      isDeleteModel: true,
      type: 'confirm',
      title: '',
      message: 'Are you sure?',
      okFunc: () => {
        client
          .deliveryVerticalDelete({ id: selectId })
          .then((response) => {
            filterData();
          })
          .catch((err) => {
            showDialog({ message: err.message });
          });
      },
    });
  }

  function getDetail(id) {
    $form = { ...defaultValue };
    $errors = {};
    serverErrors = [];

    if (id > 0) {
      client
        .deliveryVerticalDetail({ id })
        .then((response) => {
          $form = response.data;
          toggleModal();
        })
        .catch((err) => {});
    } else {
      toggleModal();
    }
  }
</script>

<div class="p-3 h-100 d-flex flex-column">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h3 class="font-size-14 mb-0">Delivery Vertical</h3>
    <button
      on:click={() => getDetail(0)}
      data-bs-target="#projectTypeModal"
      class="mb-0 px-4 font-size-13 background-blue text-white rounded border-blue btn-primary shadow-none"
      >+ Add Delivery Vertical</button
    >
  </div>
  <div
    class="ibox-content page-content mt-3"
    bind:this={scrollRef}
  >
    <DataTable
      bind:this={datatableRef}
      columns={columns}
      scrollRef={scrollRef}
      getData={getData}
      let:row
    >
      <td class="text-muted"><span class="text-break">{row.name}</span></td>
      <td width="110">
        <div class="form-check form-switch status-switch-block">
          <input
            id={row.id}
            checked={row.active === 1}
            class="form-check-input shadow-none"
            type="checkbox"
            on:change={(event) => {
              client
                .deliveryVerticalUpdateStatus({ id: row.id })
                .then((result) => {
                  row.active = event.target.checked
                    ? configItem.status.active
                    : configItem.status.inactive;
                })
                .catch((error) => {
                  event.target.checked = row.active === configItem.status.active;
                  showDialog({ message: error.message });
                });
            }}
          />
        </div>
      </td>
      <td
        class="text-muted"
        width="80"
      >
        <button
          class="btn btn-link shadow-none border-0 p-0 bg-transparent"
          on:click={() => getDetail(row.id)}
        >
          <img
            class="me-1 icon-16"
            alt=""
            src="/images/pencil-gray.svg"
          />
        </button>
        <button
          class="btn btn-link shadow-none border-0 bg-transparent p-0"
          on:click={() => showDelete(row.id)}
        >
          <img
            class="me-1 icon-16"
            alt=""
            src="/images/cancel.svg"
          />
        </button>
      </td>
    </DataTable>
  </div>
</div>
<!-- Modal -->
<div
  class="modal fade"
  id="projectTypeModal"
  tabindex="-1"
  aria-labelledby="projectTypeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5
          class="modal-title font-size-14"
          id="projectTypeModalLabel"
        >
          {$form.id != undefined && $form.id > 0 ? 'Edit' : 'Add'} Delivery Vertical
        </h5>
        <button
          data-bs-dismiss="modal"
          type="button"
          class="btn-close"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <InfoAlert
            message={serverErrors}
            class="alert alert-danger w-100 mb-3"
          />
          <div class="col-md-12">
            <div class="form-group mb-3">
              <FormInput
                name="name"
                label="Delivery Vertical"
                maxLength={configItem.maxLength.masterInput}
                type="text"
                placeholder="Enter Delivery Vertical "
                error={$errors.name}
                keypress={(event) => {
                  if (event.key == 'Enter') {
                    handleSubmit();
                  }
                }}
                bind:value={$form.name}
                handleChange={handleChange}
                bind:this={focusInput}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button
          on:click={handleSubmit}
          type="button"
          class="btn btn-primary font-size-13 px-4"
          disabled={isFormPending}
        >
          {#if isFormPending}
            <Loader />
          {:else}Save{/if}
        </button>
      </div>
    </div>
  </div>
</div>
